import React from 'react'
import DocumentImg from '../../../../assets/images/care-plans/liver-forever-program/document.png'
import Layout from '../../../../components/Layout'
import Button from '../../../../components/ButtonNew'
import DocumentIcon from '../../../../assets/icons/document.svg'
import Text from '../../../../components/Text'
import LiverForeverPorgramPosturchaseJourneyImg from '../../../../assets/images/care-plans/liver-forever-program/liver-forver-program-post-purchase-journey.png'
import { useNavigate, useParams } from 'react-router-dom'
import { getUrlParams } from '../../../../utils/helpers/common'

const LiverForeverPlanStatusPage = () => {
  const navigate = useNavigate()
  const { status } = getUrlParams()

  console.log('status', status)

  const data = {
    SOME_ISSUE_WITH_ONE_OF_DOC: {
      title: 'There seems to be some problem with the uploaded document(s)',
      description:
        'Your document(s) have been rejected. Re-upload to get started with your Liver Forever journey.',
      buttonText: 'View & Re-upload Docs',
      buttonIcon: DocumentIcon,
      buttonLink: '/care-plans/liver-forever-program/preview',
      cardType: 'error',
    },
    SOME_DOC_PENDING: {
      title: 'We are currently reviewing your documents',
      description: 'Documents are under review. This will take upto 24 hrs.',
      buttonText: 'View Documents',
      buttonIcon: DocumentIcon,
      buttonLink: '/care-plans/liver-forever-program/preview',
      cartType: 'normal',
    },
    ALL_DOC_APPROVED: {
      title: 'We are currently reviewing your documents',
      description: 'Documents are under review. This will take upto 24 hrs.',
      buttonText: 'View Documents',
      buttonIcon: DocumentIcon,
      buttonLink: '/care-plans/liver-forever-program/preview',
      cartType: 'normal',
    },
  }

  return (
    <Layout className="bg-white">
      <div
        className={`min-w-sm max-w-lg relative mx-auto w-full bg-[#F2F4F7] h-screen overflow-y-auto`}
      >
        <Text variant="headline" size="small" tag="p" className="px-4 py-6">
          Your Chronic Care Program
        </Text>
        <div className="mx-6 relative pt-[150px]">
          <div className="flex justify-center">
            <img
              src={DocumentImg}
              className="w-[159px] h-[207px] absolute top-0 z-[1]"
              alt="liver-forever-care-plan"
            />
          </div>
          <div
            className={`z-10 rounded-xl p-4 relative flex flex-col gap-3 ${
              data[status]?.cardType === 'error'
                ? 'border-2 border-red-500 bg-red-50'
                : 'bg-white'
            }`}
          >
            <Text variant="title" size="large" tag="p" bold={'true'}>
              {data[status]?.title}
            </Text>
            <Text
              variant="body"
              size="medium"
              tag="p"
              className="text-[#5A6774] pb-2"
            >
              {data[status]?.description}
            </Text>
            <Button
              fullWidth
              onClick={() =>
                navigate('/care-plans/liver-forever-program/preview')
              }
            >
              <img src={DocumentIcon} alt="document" />
              {data[status]?.buttonText}
            </Button>
          </div>
        </div>

        <img
          src={LiverForeverPorgramPosturchaseJourneyImg}
          alt="liver-forever-care-plan"
          className="pt-10"
          // className="absolute bottom-0 left-0"
        />
      </div>
    </Layout>
  )
}

export default LiverForeverPlanStatusPage
